import { map } from "rxjs";
import { BASE_API_DOMAIN, httpClient } from "../api.config";
import { catchApiError } from "../api.tools";
const BASE_URL = BASE_API_DOMAIN + "/v2/api/authenticated";
const URLS = {
    authenticated: () => BASE_URL,
};
export const authenticatedService = {
    fetchAuthenticated: () => {
        return httpClient
            .get(URLS.authenticated())
            .pipe(map(({ response }) => response), catchApiError());
    },
};
